import { InjectionToken } from '@angular/core';

import { AuthenticationConfig } from '../models/authentication-config.model';

export const AUTHENTICATION_CONFIG = new InjectionToken<AuthenticationConfig>('AuthenticationConfig');
